import React from 'react';
import 'theme/quill.ts.css';
import classNames from 'classnames';
import ReactQuill from 'react-quill';
import ButtonBase from '@material-ui/core/ButtonBase';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  cardMedia: {
    height: 108,
  },
  quill: {
    paddingLeft: 3,
    paddingRight: 3,
    '& .ql-container': {
      minHeight: 124,
    },
  },
  quillAppBar: {
    top: 56,
    zIndex: theme.zIndex.appBar - 1,
    [theme.breakpoints.up('sm')]: {
      top: 64,
    },
  },
  hide: {
    display: "none"
  },
  noShadow: {
    boxShadow: "none"
  }
});

const QuillAppBar = ({ children, classes, readOnly }) => (
  <div className={classNames(classes.quillAppBar, 'bg-white pt-4 sticky', readOnly ? classes.hide : "")}>
    <AppBar position="static">{children}</AppBar>
  </div>
);

const QuillToolbar = props => (
  <QuillAppBar {...props}>
    <Toolbar id="ql-toolbar" className="flex-wrap">
      <span className="ql-formats">
        <select
          className="ql-header"
          onChange={e => e.persist()}
          defaultValue=""
          title="Headings"
        >
          <option value={2}>Heading 2</option>
          <option value={3}>Heading 3</option>
          <option value="">Normal</option>
        </select>
      </span>
      <span className="ql-formats">
        <ButtonBase className="ql-bold" title="Bold" />
        <ButtonBase className="ql-italic" title="Italic" />
        <ButtonBase className="ql-blockquote" title="Quote" />
      </span>
      <span className="ql-formats">
        <ButtonBase className="ql-list" value="ordered" title="Numbered list" />
        <ButtonBase className="ql-list" value="bullet" title="Bulleted list" />
      </span>
      <span className="ql-formats">
        <ButtonBase className="ql-link" title="Link" />
        <ButtonBase className="ql-image" title="Insert photo" />
        <ButtonBase className="ql-video" title="Embed video" />
      </span>
      <span className="ql-formats">
        <ButtonBase className="ql-clean" title="Remove formatting" />
      </span>
    </Toolbar>
  </QuillAppBar>
);

class QuillEditor extends React.Component {
  formats = [
    'header',
    'bold',
    'italic',
    'blockquote',
    'list',
    'bullet',
    'link',
    'image',
    'video',
  ];

  modules = {
    toolbar: {
      container: '#ql-toolbar',
    },
  };
  render() {
    const { classes, value, handleContentChange, handleContentBlur, readOnly } = this.props;
    return (
      <div>
        <QuillToolbar classes={classes} readOnly={readOnly} />
        <ReactQuill
          readOnly={readOnly}
          className={classes.quill}
          style={{ boxShadow: "none !important" }}
          formats={this.formats}
          modules={this.modules}
          onChange={handleContentChange}
          onBlur={handleContentBlur}
          placeholder="Compose your story…"
          value={value}
        />
      </div>
    )
  }
}

export default withStyles(styles)(QuillEditor);
